import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Wizard/wizard';
import { css } from '@patternfly/react-styles';
import { Button } from '../Button';
import { Title } from '../Title';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
export var WizardHeader = function WizardHeader(_ref) {
  var _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return undefined;
  } : _ref$onClose,
      title = _ref.title,
      description = _ref.description,
      hideClose = _ref.hideClose,
      closeButtonAriaLabel = _ref.closeButtonAriaLabel,
      titleId = _ref.titleId,
      descriptionId = _ref.descriptionId;
  return React.createElement("div", {
    className: css(styles.wizardHeader)
  }, !hideClose && React.createElement(Button, {
    variant: "plain",
    className: css(styles.wizardClose),
    "aria-label": closeButtonAriaLabel,
    onClick: onClose
  }, React.createElement(TimesIcon, {
    "aria-hidden": "true"
  })), React.createElement(Title, {
    headingLevel: "h2",
    size: "3xl",
    className: css(styles.wizardTitle),
    "aria-label": title,
    id: titleId
  }, title || React.createElement(React.Fragment, null, "\xA0")), description && React.createElement("p", {
    className: css(styles.wizardDescription),
    id: descriptionId
  }, description));
};